import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/UserSettings/UserSettingsSubNav';

export const UserSettingsLayout = () => LayoutWithSubNav({ navId });
